/* eslint-disable @nx/enforce-module-boundaries */
import { Route } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { canActivateFn, canMatchFn } from '@kanzi-apes/kanzi-auth';
import { LayoutMainViewComponent } from './components/layout-main-view/layout-main-view.component';
import { importProvidersFrom } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as LocationState from '@kanzi-apes/kanzi-location';
import * as CustomerState from '@kanzi-apes/kanzi-customer';

const kanziTitle = 'Kanzi RFID';

export const appRoutes: Route[] = [
  {
    path: 'flights-board',
    loadChildren: () =>
      import('@kanzi-apes/kanzi-air-cargo').then(
        (m) => m.kanziAirCargoBoardRoutes
      ),
    title: kanziTitle + ' - Flights Board',
    providers: [],
  },
  {
    path: '',
    component: LayoutComponent,
    providers: [
      importProvidersFrom(
        StoreModule.forFeature(
          LocationState.LOCATIONS_FEATURE_KEY,
          LocationState.locationsReducer
        )
      ),
      importProvidersFrom(
        StoreModule.forFeature('customer', CustomerState.reducers)
      ),
    ],
    title: kanziTitle,
    data: {
      breadcrumb: 'menu_breadcrumb.home',
    },
    canActivate: [canActivateFn],
    children: [
      {
        path: '',
        component: LayoutMainViewComponent,
      },
      {
        path: 'third-party',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-contacts').then(
            (m) => m.KanziContactsModule
          ),
        title: kanziTitle + ' - Third Party',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.thirds',
        },
        providers: [],
      },
      {
        path: 'products',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-products').then(
            (m) => m.kanziProductsRfidRoutes
          ),
        title: kanziTitle + ' - Products',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.products',
        },
        providers: [],
      },
      {
        path: 'inventories',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-stock-summary').then(
            (m) => m.KanziStockSummaryModule
          ),
        title: kanziTitle + ' - Inventories',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.inventories',
        },
      },
      {
        path: 'moves',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-moves').then((m) => m.KanziMovesModule),
        title: kanziTitle + ' - Moves',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.moves',
        },
      },
      {
        path: 'production-orders',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-production-order').then(
            (m) => m.KanziProductionOrderModule
          ),
        title: kanziTitle + ' - Production Orders',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.production_orders',
        },
      },
      {
        path: 'purchase-orders',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-purchase-order').then(
            (m) => m.KanziPurchaseOrderModule
          ),
        title: kanziTitle + ' - Purchase Orders',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.purchase_orders',
        },
      },
      {
        path: 'print-orders',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-print-order').then(
            (m) => m.KanziPrintOrderModule
          ),
        title: kanziTitle + ' - Print Orders',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.print_orders',
        },
      },
      {
        path: 'operations/packing-audits',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-packing-audits').then(
            (m) => m.kanziPackingAuditsRoutes
          ),
        title: kanziTitle + ' - Packing Audits',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.packing_audits',
        },
        providers: [],
      },
      {
        path: 'operations',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-operations').then(
            (m) => m.KanziOperationsModule
          ),
        title: kanziTitle + ' - Operations',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.operations',
        },
      },
      {
        path: 'packings',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-logistic-packing').then(
            (m) => m.KanziLogisticPackingModule
          ),
        title: kanziTitle + ' - Packings',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.packings',
        },
      },
      {
        path: 'logistics',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-logistics').then(
            (m) => m.KanziLogisticsModule
          ),
        title: kanziTitle + ' - Logistics',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.logistics',
        },
      },
      {
        path: 'audits',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-audits').then((m) => m.KanziAuditsModule),
        title: kanziTitle + ' - Audits',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.inventories_counts',
        },
      },
      {
        path: 'rfid-nodes',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-rfid-nodes').then(
            (m) => m.kanziRfidNodesRoutes
          ),
        title: kanziTitle + ' - RFID Nodes',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.rfid_nodes',
        },
        providers: [],
      },

      {
        path: 'audits-classic',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-audits-classic').then(
            (m) => m.KanziAuditsClassicModule
          ),
        title: kanziTitle + ' - Audits',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.inventories_counts',
        },
      },
      {
        path: 'analytics',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-analytics-reports').then(
            (m) => m.KanziAnalyticsReportsModule
          ),
        title: kanziTitle + ' - Analytics',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.analytics',
        },
      },
      {
        path: 'screen-control',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-screen-control').then(
            (m) => m.kanziScreenControlRoutes
          ),
        title: kanziTitle + ' - Screen Control',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.screen_control',
        },
        providers: [],
      },
      {
        path: 'integration-apps',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-integration-rfid-apps').then(
            (m) => m.kanziIntegrationRfidAppsRoutes
          ),
        title: kanziTitle + ' - Integration Apps',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.integration_apps',
        },
        providers: [],
      },
      {
        path: 'stock-sales',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-stock-sales').then(
            (m) => m.KanziStockSalesModule
          ),
        title: kanziTitle + ' - Stock Sales',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.stock_sales',
        },
        providers: [],
      },
      {
        path: 'sales',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-sales').then((m) => m.salesRoutes),
        title: kanziTitle + ' - Sales',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.sales',
        },
        providers: [],
      },
      {
        path: 'locations',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-location').then(
            (m) => m.KanziLocationModule
          ),
        title: kanziTitle + ' - Locations',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.locations',
        },
      },
      {
        path: 'users',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-users').then((m) => m.usersRoutes),
        title: kanziTitle + ' - Users',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.users',
        },
      },
      {
        path: 'settings/readers',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-rfid-readers').then(
            (m) => m.kanziRfidReadersRoutes
          ),
        title: kanziTitle + ' - RFID Readers',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.settings',
        },
        providers: [],
      },
      {
        path: 'settings/rfid',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-rfid-print-templates').then(
            (m) => m.kanziRfidPrintTemplatesRoutes
          ),
        title: kanziTitle + ' - RFID Configuration',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.rfid_configuration',
        },
        providers: [],
      },
      {
        path: 'air-cargo',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-air-cargo').then(
            (m) => m.kanziAirCargoRoutes
          ),
        title: kanziTitle + ' - Air Cargo',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.air_cargo',
        },
        providers: [],
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('@kanzi-apes/kanzi-auth').then((m) => m.kanziAuthRfidRoutes),
    title: kanziTitle + ' - Login',
    providers: [],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
